import { myStudentsCoursesRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const permission = [IRoleEnum.Teacher, IRoleEnum.ASSISTANT];

const myStudentsCoursesRouteMetadata: IRouteMetadataObj<
  typeof myStudentsCoursesRoutesObj
> = {
  list: {
    title: "myStudentsCourses.index.title",
    description: "myStudentsCourses.index.description",
    lazy: () =>
      import("@/pages/teacherPages/myTrainingCourseStudent/table/page"),
    mode: "index",
    type: "main",
    icon: "GroupLine",
    breadcrumbs: [],
    permission,
  },
  view: {
    title: "myStudentsCourses.view.title",
    description: "myStudentsCourses.view.description",
    lazy: () =>
      import("@/pages/teacherPages/myTrainingCourseStudent/view/page"),
    mode: "view",
    type: "inner",
    icon: "GraduationCapLine",
    breadcrumbs: [],
    permission,
    isPageFullMode: false,
  },
  viewOnlineExamScore: {
    title: "myStudentsCourses.viewOnlineExamScore.title",
    description: "myStudentsCourses.viewOnlineExamScore.description",
    lazy: () =>
      import(
        "@/pages/teacherPages/myTrainingCourseStudent/showOnlineExamScore/form/page"
      ),
    mode: "view",
    type: "inner",
    icon: "FileEditLine",
    breadcrumbs: [],
    permission,
  },
  viewDescriptiveExamScore: {
    title: "myStudentsCourses.viewDescriptiveExamScore.title",
    description: "myStudentsCourses.viewDescriptiveExamScore.description",
    lazy: () =>
      import(
        "@/pages/teacherPages/myTrainingCourseStudent/showDescriptiveExamScore/form/page"
      ),
    mode: "edit",
    type: "inner",
    icon: "FileChartLine",
    breadcrumbs: [],
    permission,
  },
  editDescriptiveExamScore: {
    title: "myStudentsCourses.viewDescriptiveExamScore.title",
    description: "myStudentsCourses.viewDescriptiveExamScore.description",
    lazy: () =>
      import(
        "@/pages/teacherPages/myTrainingCourseStudent/showDescriptiveExamScore/form/page"
      ),
    mode: "create",
    type: "inner",
    icon: "FileChartLine",
    breadcrumbs: [],
    permission,
  },
};

export const myStudentsCoursesRoutes = createRoute<
  typeof myStudentsCoursesRoutesObj
>(myStudentsCoursesRoutesObj, myStudentsCoursesRouteMetadata);
